<!-- Shou active users in table -->
<div class="users" id="activeUsr">
  <div class="data_header" id="dataHeaderActiveUsr">
    <div class="left_side_section" id="activeUsrLeftSide">
      <div class="mr-3" id="activeUsrTtleMain">
        <div class="title" id="activeUsrTitle"><span i18n="@@active-users.title.active-users">Active Users</span></div>
        <div class="results" *ngIf="usersData?.length > 0" id="showFrmActiveUsr">
          <span i18n="@@active-users.results.showing-of-users" class="showing">Showing <strong>{{ showFrom }} - {{
              showTo }}</strong> of <strong>{{ paginationCount }} Users</strong></span>
        </div>
      </div>
      <div class="input-group" [ngClass]="{'input-group-lan': !isEnglish,'ukraine-width':isUkraine}"
        *ngIf="loginUserRole!='storeUser'" id="inputGrpLan">
        <input type="search" #searchValue class="form-control input" [(ngModel)]="searchData"
          (keyup.enter)="searchtheUserssonEnter(searchData)" placeholder={{searchPlaceholder}} maxlength="75"
          (ngModelChange)="clearSearch(searchData)" />
        <div ngbDropdown class="btn-group" id="btnGrp">
          <button ngbDropdownToggle type="button" class="btn btn-primary dropdown-toggle" id="sizeDropDown"
            aria-haspopup="true" aria-expanded="false">
            {{ valueForSearchinUsers }}
          </button>
          <div ngbDropdownMenu aria-labelledby="sizeDropDown" id="sizeDropDown">
            <a ngbDropdownItem selected="selected" *ngIf="valueForSearchinUsers!=nameVal"
              (click)="onSelectChange('1')"><span i18n="@@active-users.dropdown-text.name">Name</span></a>
            <a ngbDropdownItem *ngIf="valueForSearchinUsers!=emailVal" (click)="onSelectChange('2')"><span
                i18n="@@active-users.dropdown-text.email">Email</span></a>
            <a ngbDropdownItem *ngIf="valueForSearchinUsers!=retailHQVal && loginUserRole==='intelAdmin'"
              (click)="onSelectChange('3')"><span i18n="@@active-users.dropdown-text.retail-hq">Retail HQ</span></a>
            <a ngbDropdownItem *ngIf="valueForSearchinUsers!=storesVal" (click)="onSelectChange('4')"><span
                i18n="@@active-users.dropdown-text.stores">Stores</span></a>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary ml-2 search_btn gtmUsersActiveUsersSearch"
        *ngIf="loginUserRole!='storeUser'" (click)="searchActiveUsers(searchData)">
        <img class="searchicon" alt="search" />
      </button>
    </div>
    <iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true" (getStatus)='isLoading = $event'>
    </iposcen-spinner-overlay>
    <iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false" (getStatus)='isLoading = $event'>
    </iposcen-spinner-overlay>
    <div *ngIf="showPopupSpinner">
      <iposcen-spinner-overlay [isCard]="false" [isActiveUser]="true">
      </iposcen-spinner-overlay>
    </div>
    <!-- TODO once fixed for SVG -->
    <div class="action_buttons" [ngClass]="{'action_btn_arabic': isArabic }" id="gtmUserNewUsrBtn">
      <button type="button" class="btn btn-outline-primary btn-lg left_icon_btn gtmUsersStoresBatchAdd"
        (click)="EnableDeleteMultipleStores()" *ngIf="loginUserRole== storeUser ? false : (loginUserRole== intelAdmin || retailHQUser || regionalHQUser) && !multiSelectClicked && usersData?.length>1">
        <img class="store_delete" alt="delete store">
        <span>{{globConst.DEL_MULTI_USERS}}</span>
      </button>
      <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmUsersNewUser" [ngClass]="{'mt-2':isRussian}"
        (click)="inviteNewUser()" *ngIf="!multiSelectClicked">
        <img class="plus-square" alt="New User" />
        <span i18n="@@active-users.invite-user.new-user">New User</span>
      </button>
      <button type="button" class="btn btn-outline-primary btn-lg left_icon_btn gtmUsersStoresBatchAdd"
        *ngIf="multiSelectClicked" (click)="cancelMultiSelect()">
        <span>{{globConst.CANCEL}}</span>
      </button>
      <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmUsersNewStore" *ngIf="multiSelectClicked"
        (click)="showMultiUserDelPopup()" [disabled]="checkDisable()">
        <img alt="delete users" [ngClass]="checkDisable()?'disabled_white':'blue_delete_icon'">
        <span>{{globConst.DEL_SELECTED}}</span>
      </button>
    </div>
  </div>
  <!-- Filter Data  -->
  <div class="filter_options" *ngIf="loginUserRole!='storeUser'" id="filtrrOptionActiveUsr">
    <div class="form-inline" id="frmInline">
      <span id="filterfont" class="mr-4" i18n="@@active-users.filter-options.filters">Filters</span>
      <select *ngIf="loginUserRole === intelAdmin && !retailHQDropdownSelectedValue" #drop1
        (change)="onFilter(retailhqFilterName, drop1.value)" class="btn-greyscale btn-sm dropdown-toggle"
        [ngClass]="{'btn-greyscale-lan':!isEnglish,'btn-greyscale-lan-uk':isUkraine}" aria-haspopup="true"
        aria-expanded="false">
        <option selected default class="option-default"><span i18n="@@active-users.retail.retail-hq">Retail HQs</span>
        </option>
        <option class="dropdown-item" *ngFor="let retailHQ of allActiveUserRetailHQs" [value]="retailHQ">{{
          retailHQ.length > 25 ? (retailHQ | slice:0:25) + '...' : retailHQ }}
        </option>
      </select>
      <div [ngbTooltip]="retailHQDropdownSelectedValue?.length > 25 ? retailHQDropdownSelectedValue:''"
        class="dropdown-selected" *ngIf="retailHQDropdownSelectedValue" id="dropDownRetailHQ">{{retailHQDropdownSelectedValue?.length > 25 ?
        (retailHQDropdownSelectedValue | slice:0:25) + '...' : retailHQDropdownSelectedValue}}
        <img src="assets/images/close.svg" class="dropdown-selected-img" (click)="clearFilter(retailhqFilterName)"
          alt="close" />
      </div>
      &nbsp;&nbsp;
      <select #drop2 (change)="onFilter(roleFilterName, drop2.value)" *ngIf="!rolesDropdownSelectedValue"
        class="btn-greyscale btn-sm dropdown-toggle" [ngClass]="{'btn-greyscale-lan': !isEnglish}" aria-haspopup="true"
        aria-expanded="false">
        <option selected default class="option-default"><span i18n="@@active-users.roles-dropdown.roles">Roles</span>
        </option>
        <option class="dropdown-item" *ngFor="let role of allActiveUserRoles" [value]="role">{{spell(role)}}
        </option>
      </select>
      <div class="dropdown-selected" *ngIf="rolesDropdownSelectedValue" id="rolesDrpDwnSelectVal">{{rolesDropdownSelectedValue}}
        <img src="assets/images/close.svg" class="dropdown-selected-img" (click)="clearFilter(roleFilterName)"
          alt="close" />
      </div>
      &nbsp;&nbsp;
      <select #drop3 (change)="onFilter(countryFilterName, drop3.value)" *ngIf="!countriesDropdownSelectedValue"
        class="btn-greyscale btn-sm dropdown-toggle" [ngClass]="{'btn-greyscale-lan':!isEnglish}" aria-haspopup="true"
        aria-expanded="false">
        <option selected default class="option-default"><span
            i18n="@@active-users.countries-dropdown.location">Location</span></option>
        <option class="dropdown-item" *ngFor="let country of allActiveUserCountries" [value]="country"> {{ getTranslatedLoc(country) }}
        </option>
      </select>
      <div class="dropdown-selected" *ngIf="countriesDropdownSelectedValue" id="countriesDrpDwn">{{getTranslatedLoc(countriesDropdownSelectedValue)}}
        <img src="assets/images/close.svg" class="dropdown-selected-img" (click)="clearFilter(countryFilterName)"
          alt="close" />
      </div>
    </div>
    <div class="btn left_icon_btn" (click)="clearFilter()" *ngIf="closeFilter" id="btnLeftIcon">
      <img src="assets/images/close.svg" alt="close" />
      <span class="btn-link" i18n="@@active-users.filters.clear-filters">Clear Filters</span>
    </div>
  </div>
  <hr />

  <div class="container" *ngIf="showAddStoresPopUp" id="containerActiveUsr">
    <div class="modal-dialog modal-dialog-centered" id="modalDialog">
      <div class="modal-backdrop show" id="modalBackDrp"></div>
      <div class="modal" id="activeUsrModal">
        <div class="modal-dialog" id="activeUsrModalDialog">
          <div class="modal-content" id="activeUsrModalContent">
            <div class="close" data-dismiss="modal" id="activeUsrModalClose">
              <img class="modal-close-icon" alt="close" />
            </div>
            <div class="modal-body" id="activeUsrModalBody">
              <div class="heading csv-modal-heading" id="csvModalHeading"><span i18n="@@active-users.csv.add-stores-via-csv">Add Stores via
                  CSV</span></div>
              <span class="font-weight-bold">1. </span><a href="assets/csv/StoresCSV.csv" class="download"><span
                  i18n="@@active-users.download.download-csv-template">Download CSV Template</span></a>
              <div class="csv-upload-div" id="csvUploadDiv">
                <span class="font-weight-bold"
                  i18n="@@active-users.populate.populate-the-csv-template-with-the-stores-you-would-like-to-add">2.
                  Populate the CSV template with the stores you would like to add</span>
              </div>
              <div class="upload-submit-txt" id="uploadSubmitTxt">
                <span class="font-weight-bold" i18n="@@active-users.submit.upload-and-submit-the-completed-template:">3.
                  Upload and submit the
                  completed template</span>:
              </div>
              <!-- TODO once fixed for SVG -->
              <div id="filePickerSvg">
                <input type="file" id="file-picker" accept=".csv" hidden />
                <button type="button"
                  class="btn btn-primary btn-lg left_icon_btn upload-csv-btn gtmUsersActiveUsersUploadCSV">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.33071 9.30042L5.88471 9.05292C5.37346 8.96647 4.84984 8.98699 4.34692 9.11317C3.844 9.23935 3.37271 9.46845 2.96282 9.78601C2.55294 10.1036 2.21336 10.5027 1.96554 10.9581C1.71772 11.4136 1.56704 11.9155 1.52302 12.4321C1.47901 12.9487 1.54261 13.4689 1.70981 13.9597C1.87702 14.4505 2.14419 14.9013 2.49445 15.2836C2.84471 15.6659 3.27045 15.9715 3.74477 16.1809C4.2191 16.3903 4.73171 16.4991 5.25021 16.5004H9.00021V18.0004H5.25021C4.52341 18.0003 3.80454 17.8493 3.13913 17.5569C2.47372 17.2646 1.87626 16.8372 1.38459 16.302C0.892912 15.7667 0.517733 15.1352 0.282804 14.4474C0.0478744 13.7596 -0.0416861 13.0305 0.0197929 12.3063C0.0812719 11.5821 0.292451 10.8786 0.639959 10.2402C0.987466 9.6019 1.46373 9.04266 2.0386 8.59794C2.61347 8.15322 3.27441 7.83271 3.97958 7.6567C4.68475 7.48069 5.41879 7.45301 6.13521 7.57542C6.31291 6.59325 6.68479 5.6564 7.22908 4.81974C7.77336 3.98309 8.47911 3.26343 9.30499 2.70293C10.1309 2.14243 11.0603 1.75235 12.0388 1.55553C13.0173 1.3587 14.0253 1.3591 15.0037 1.55669C15.982 1.75428 16.9111 2.14509 17.7366 2.70624C18.562 3.26739 19.2672 3.98759 19.8108 4.82468C20.3545 5.66176 20.7256 6.5989 20.9025 7.58121C21.0795 8.56353 21.0586 9.57127 20.8412 10.5454C21.7716 10.6957 22.6113 11.1906 23.1934 11.9317C23.7755 12.6729 24.0573 13.6059 23.9828 14.5454C23.9083 15.4849 23.483 16.3619 22.7914 17.002C22.0998 17.6422 21.1926 17.9986 20.2502 18.0004H15.0002V16.5004H20.2502C20.8158 16.5001 21.3606 16.2867 21.7759 15.9028C22.1913 15.5188 22.4468 14.9926 22.4917 14.4287C22.5365 13.8649 22.3673 13.3049 22.0178 12.8602C21.6683 12.4154 21.1642 12.1187 20.6057 12.0289L19.0502 11.7814L19.3742 10.2394C19.5305 9.46696 19.5331 8.67127 19.3819 7.89778C19.2307 7.1243 18.9287 6.38817 18.493 5.73143C18.0573 5.07469 17.4965 4.51019 16.8427 4.07017C16.1888 3.63015 15.4547 3.32323 14.6822 3.16692C13.9097 3.01062 13.1141 3.00799 12.3406 3.15919C11.5671 3.3104 10.831 3.61247 10.1742 4.04816C9.51748 4.48385 8.95298 5.04463 8.51296 5.69849C8.07294 6.35234 7.76602 7.08646 7.60971 7.85892L7.33221 9.29892L7.33071 9.30042Z" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7.49964 13.2806C7.64028 13.4212 7.83101 13.5002 8.02989 13.5002C8.22876 13.5002 8.41949 13.4212 8.56014 13.2806L11.9996 9.83964L15.4391 13.2791C15.5083 13.3508 15.5911 13.4079 15.6826 13.4472C15.7741 13.4865 15.8725 13.5072 15.9721 13.5081C16.0717 13.5089 16.1704 13.49 16.2626 13.4523C16.3548 13.4145 16.4385 13.3589 16.5089 13.2884C16.5794 13.218 16.635 13.1343 16.6728 13.0421C16.7105 12.9499 16.7294 12.8512 16.7286 12.7516C16.7277 12.652 16.707 12.5536 16.6677 12.4621C16.6284 12.3706 16.5713 12.2878 16.4996 12.2186L12.5306 8.24964C12.461 8.17979 12.3782 8.12438 12.2871 8.08657C12.196 8.04876 12.0983 8.0293 11.9996 8.0293C11.901 8.0293 11.8033 8.04876 11.7122 8.08657C11.6211 8.12438 11.5383 8.17979 11.4686 8.24964L7.49964 12.2186C7.42979 12.2883 7.37438 12.3711 7.33657 12.4622C7.29876 12.5533 7.2793 12.651 7.2793 12.7496C7.2793 12.8483 7.29876 12.946 7.33657 13.0371C7.37438 13.1282 7.42979 13.211 7.49964 13.2806Z" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12 9C12.1989 9 12.3897 9.07902 12.5303 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V21.75C12.75 21.9489 12.671 22.1397 12.5303 22.2803C12.3897 22.421 12.1989 22.5 12 22.5C11.8011 22.5 11.6103 22.421 11.4697 22.2803C11.329 22.1397 11.25 21.9489 11.25 21.75V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6103 9.07902 11.8011 9 12 9Z" />
                  </svg>
                  <span i18n="@@active-users.upload.upload-csv">Upload CSV</span>
                </button>
                <div class="text-align-filename" id="txtAlgnFileNam"></div>
                <div class="text-align-filename" id="fileCSVFormat">
                  <span class="text-danger" i18n="@@active-users.file.file-must-be-csv">File must be in CSV
                    format</span>
                </div>
                <div class="text-align-filename" id="txtAlignFileNam">
                  <!-- TODO: Had a seperate span tag here: CSV Template with download class. Removed for GLS work -->
                  <span class="text-danger" i18n="@@active-users.confirm.uploaded-csv-does-not-confirm-to-the">Uploaded
                    CSV does not conform to the CSV Template</span>
                </div>
              </div>
            </div>
            <div class="modal-footer" id="modalFooterActiveUsr">
              <div class="button-wrapper" id="activeUsrBtnWrappr">
                <button type="button" class="btn btn-outline-primary">
                  <span i18n="@@active-users.cancel">Cancel</span>
                </button>
                <button type="button" class="btn btn-primary">
                  <span i18n="@@active-users.upload.upload-csv">Upload CSV</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Table data -->
  <div class="table-responsive" id="tblResStores">
    <table id="storesTable" class="table table-borderless" aria-describedby="stores">
      <thead *ngIf="usersData?.length > 0">
        <tr>
          <th scope="col"
            *ngIf="multiSelectClicked && userRole == intelAdmin && !this.retailHQDropdownSelectedValue; else otherPart">
            <input type="checkbox" (change)="selectDeSelectAll($event,globConst.ALL_TEXT)" placement="right"
              ngbTooltip={{globConst.USER_SELECT_ALL_POPUP_TEXT}} tooltipClass="my-custom-class"
              [ngClass]="!retailHQDropdownSelectedValue && userRole == this.intelAdmin? 'disableCheckBox':''" />
          </th>
          <ng-template #otherPart>
            <th scope="col" *ngIf="multiSelectClicked">
              <input type="checkbox" [checked]="checkUncheckFlag || selectDeSelectAllFlag" (change)="selectDeSelectAll($event,globConst.ALL_TEXT)" />
            </th>
          </ng-template>
          <th scope="col" id="retailHq">
            <span class="table_headings" (click)="sort(name)">
              <span i18n="@@active-users.name">Name</span>
              <span *ngIf="loginUserRole!='storeUser'" class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="custstoreID">
            <span class="table_headings" (click)="sort(email)">
              <span i18n="@@active-users.dropdown-text.email">Email</span>
              <span *ngIf="loginUserRole!='storeUser'" class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="createby">
            <span class="table_headings" (click)="sort(retailer)">
              <span i18n="@@active-users.retail.retail-hq">Retail HQ</span>
              <span *ngIf="loginUserRole!='storeUser'" class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="storenum">
            <span class="table_headings" (click)="sort(store)">
              <span i18n="@@active-users.heading-store-name.store-name">Store Name</span>
              <span *ngIf="loginUserRole!='storeUser'" class="chevron_expand"></span>
            </span>
          </th>
          <th *ngIf="loginUserRole === 'intelAdmin'" scope="col" id="profilesCount">
            <span class="table_headings" (click)="sort(profileCount)">
              <span>{{createdProfilesText}}</span>
              <span class="chevron_expand"></span>
            </span>
          </th>
          <th scope="col" id="country">
            <span class="table_headings">
              <span i18n="@@active-users.role">Role</span>
            </span>
          </th>
          <th scope="col" id="region">
            <span class="table_headings" (click)="sort(location)">
              <span i18n="@@active-users.country">Location</span>
              <span *ngIf="loginUserRole!='storeUser'" class="chevron_expand"></span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of usersData;let i = index">
          <tr class="row_hover" (mouseout)="data.hover = false" (mouseover)="data.hover = true">
            <td *ngIf="multiSelectClicked">
              <input type="checkbox" [checked]='selectedUsers[usersData[i].userID]'
                (change)="selectDeSelectAll($event,globConst.SINGLE,usersData[i].userID,usersData[i].role, data.name)" [disabled]="data?.role == intelAdmin || data?.userID == usrID" />
            </td>
            <td class="bold_name">{{ data.name }}</td>
            <td>{{ data.email }}</td>
            <td *ngIf="checkIfSingle(data.retailerName)">{{ data.retailerName ? data.retailerName : NA}}</td>
            <td *ngIf="!checkIfSingle(data.retailerName, data?.userID)">
              <span>{{spllitedRetailerName.get(data?.userID)[0]}}</span>
              <span class="popup-badge" [ngbPopover]='popUpRHQ'
                [popoverTitle]="spllitedRetailerName.get(data?.userID).length + ' Retail HQs'" placement="right">
                +{{spllitedRetailerName.get(data?.userID)?.length-1}}</span>
              <ng-template #popUpRHQ>
                <div id="retailMainDiv">
                  <div
                    [ngClass]="{'popup-size-scroll':spllitedRetailerName.get(data?.userID).length>5,'popup-size':spllitedRetailerName.get(data?.userID).length<=5}" id="retailChildDiv">
                    <ul class='reduceLeftPad'>
                      <li *ngFor='let retail of spllitedRetailerName.get(data?.userID).sort()' class="child">{{retail}}
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-template>
            </td>
            <td>{{ data.storeName ? data.storeName: NA }}</td>
            <td *ngIf="loginUserRole === 'intelAdmin'">{{ data?.profileCount}}</td>
            <td *ngIf="data.role">
              <button type="button" class="disableHand" [ngClass]="checkRole(data.role)" aria-haspopup="true"
                aria-expanded="false">
                {{ spell(data?.role) }}
              </button>
              <!-- <button type="button" class="btn retailer-color" *ngIf="data.role === 'retailHq'" aria-haspopup="true"  aria-expanded="false">
                {{ data.role }}
              </button>
              <button type="button" class="btn store-color" *ngIf="data.role === 'store'" aria-haspopup="true"  aria-expanded="false">
                {{ data.role }}
              </button> -->
            </td>
            <!-- <td>{{ data.role }}</td> -->
            <td>{{ getTranslatedLoc(data.location) }}</td>
            <td *ngIf="data.role !== intelAdmin && loginUserRole !== storeUser && (loginUserRole === intelAdmin || retailHQUser || regionalHQUser)">
              <div *ngIf="loggedInUserId !== data.userID" class="deleteicon-container">
                <button class="btn btn-link delete-user" *ngIf="!showDelete[i] && !multiSelectClicked"
                  (click)="showDeleteUserPopup(data.userID, data.name, data.role)">
                  <img class="deleteicon" alt="delete" />
                </button>
                <button class="btn btn-link" *ngIf="showDelete[i] && !multiSelectClicked"
                  (click)="showDeleteUserPopup(data.userID, data.name, data.role)">
                  <img class="deleteicon" alt="delete" />
                </button>
              </div>
              <div class='placement' *ngIf="!(data.role !== intelAdmin && loginUserRole !== storeUser) && !(loginUserRole === intelAdmin || retailHQUser || regionalHQUser)">
              </div>
            </td>
            <td class="action_cell">
              <div class="modify_record" id="modifyRecord">
                <span class="table_collapse_link collapsed" data-toggle="collapse" aria-expanded="true"
                  data-target="#storesTable">
                  <img class="table_row_expanded" alt="expand" [ngClass]="expanded[i] ? 'transform-180' : ''"
                    (click)="getUsersbyID(i)" />
                </span>
              </div>
            </td>
          </tr>
          <!-- TODO in the Next PR  instead of DIV, Forms should be replaced-->
          <tr *ngIf="expanded[i]" class="detail_row_view" data-parent="#storesTable">
            <td colspan="100%">
              <div class="d-flex" id="detailRowFlex">
                <div class="border-right" id="detailBordrRight">
                  <div class="data_column" id="detailDataColumn">
                    <div id="expand_data_region"><span i18n="@@active-users.expand-details.details">Details</span></div>
                    <div class="expand_editable_data" id="expandEditData">
                      <div class="form-group" id="frmGrpFirstNam">
                        <label><span i18n="@@active-users.label-firstname.first-name">First Name</span></label>
                        <div class="exapnd_data_det" id="expandDataDet">{{ data?.firstName }}</div>
                      </div>
                      <div class="form-group" id="lastNameLbl">
                        <label><span i18n="@@active-users.label-lastname.last-name">Last Name</span></label>
                        <div class="exapnd_data_det" id="dataLastNam">{{ data?.lastName }}</div>
                      </div>
                      <div class="form-group" id="frmGrpEmail">
                        <label><span i18n="@@active-users.dropdown-text.email">Email</span></label>
                        <div class="exapnd_data_det_id" id="dataEmail">{{ data?.email }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border-right" id="organizatnMainDiv">
                  <div class="data_column" id="dataColum">
                    <div id="expand_data_region"><span
                        i18n="@@active-users.label-organization.organization">Organization</span></div>
                    <div class="d-flex" id="expandDataRegion">
                      <div class="expand_editable_data_2" id="expandEditableData">
                        <div *ngIf="data.role !== intelAdmin" class="form-group" id="retailHQFrmGrp">
                          <label><span i18n="@@active-users.retail.retail-hq">Retail HQ</span></label>
                          <div *ngIf="checkIfSingle(data.retailerName)" class="exapnd_data_det_id" id="retailerNAme">
                            {{ data?.retailerName }}
                          </div>
                          <div *ngIf="!checkIfSingle(data.retailerName)" class="exapnd_data_det_id" id="expandDataDetId">
                            <span>{{spllitedRetailerName.get(data?.userID)[0]}}</span>
                            <span class="popup-badge" [ngbPopover]='popUpRQ'
                              [popoverTitle]="spllitedRetailerName.get(data?.userID).length + ' Retail HQs'"
                              placement="right"> +{{spllitedRetailerName.get(data?.userID)?.length-1}}</span>
                            <ng-template #popUpRQ>
                              <div id="spllitedRtailerNam">
                                <div
                                  [ngClass]="{'popup-size-scroll':spllitedRetailerName.get(data?.userID).length>5,'popup-size':spllitedRetailerName.get(data?.userID).length<=5}" id="retailChild">
                                  <ul class='reduceLeftPad'>
                                    <li *ngFor='let retail of spllitedRetailerName.get(data?.userID).sort()'
                                      class="child">{{retail}}</li>
                                  </ul>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                          <!-- Button trigger edit RetailerHQ modal -->
                          <button *ngIf=" (data.role == 'regionalHQ') && loginUserRole === intelAdmin"
                            (click)="openRegionalHQModal(data?.userID,data)" type="button"
                            class="btn btn-outline-primary editretailerHQ-button">Edit</button>

                          <!-- Edit RetailerHQ Modal -->
                          <div *ngIf="showEditRegionalHQModal" id="editRetailerHQ">
                            <div class="modal-dialog modal-dialog-centered" role="document" id="modalDialog">
                              <div class="modal-backdrop show" id="modalBackDrpEdit"></div>
                              <div class="modal profileSwitchPopUp" id="profileSwitchPopup">
                                <div class="modal-dialog" id="modalProfileSwtich">
                                  <div class="modal-content regional_modal_content confirmPopup" id="regionalContentModal">
                                    <div class="modal-header" id="modalHeader">
                                      <div (click)="closePopup()" class="close-icon" id="popupClose">
                                        <div class="popup-close-icon" id="closeIcon"></div>
                                      </div>
                                    </div>
                                    <div class="modal-body regional-multi-drop" id="regionalMultiDrp">
                                      <div class="convert-container regional-pop-up" id="regionalPopup">
                                        <h2>
                                          <ng-container *ngIf='saveRegionalChanges'>
                                            <span
                                              i18n="@@active-users.save-regional-changes.do-you-want-to-save-the-changes">Do
                                              you want to save the changes?</span>
                                          </ng-container>
                                          <ng-container *ngIf='!saveRegionalChanges && !savedRegional'>
                                            <span>{{data?.name}}</span>
                                          </ng-container>
                                        </h2>
                                        <ng-container *ngIf='!saveRegionalChanges && !savedRegional'>
                                          <div class="card-desc" id="cardDescRegional">
                                            <div id="regionalEmailId">
                                              <div id="emailPopupRegionalHQ">
                                                <div for="emailPopupRegionalHQ" id="emailIdHQ">{{globConst.EMAIL_ID}}</div>
                                                <input class="disabled-input card-desc-retailerHQ" type="text"
                                                  [value]="data?.email" [disabled]='true'>
                                              </div>
                                              <div class="mt-3" id="regionalCountry">
                                                <div id="globalConstCountry">
                                                  <span>{{globConst.COUNTRY}}</span>
                                                </div>
                                                <!-- commenting pc finder (srt user) role code-->
                                                <!-- <span i18n="@@active-users.regional-location.regional-user-note"
                                                  class="note-color"><strong>Note:</strong> {{(data.role === 'srtUser') ? 'The PC Finder user operates from this location, which is independent of any Retail HQs associated to the user.' : 'The Regional user operates from this location, which is independent of any Retail HQs associated to the Regional user.'}}</span> -->
                                                <input class="mt-2 disabled-input card-desc-retailerHQ" type="text"
                                                  [value]="data?.location" [disabled]='true'>
                                                <div class="mt-2" id="retailHQAssigned">
                                                  <span i18n="@@active-users.retail-hq.to-assign">Retail HQs to be
                                                    Assigned</span>
                                                </div>
                                                <div *ngIf="retaileHQList.length < 2" class="formfield_err_msg errMsg" id="atleastTwoRetailHQ">
                                                  * <span>{{globConst.REGIONAL_USER_ASSIGNEES}}</span>
                                                </div>
                                                <div class="mt-2 border regionalsection" id="regionalSelection">
                                                  <div class="chip regionalsectionChip cursor-pointer"
                                                    *ngFor="let eachRetailHQ of retaileHQList | slice: 0:5" id="retailHQList">
                                                    <span class="mr-1">{{eachRetailHQ}}</span>
                                                    <span class="ng-value-icon right"
                                                      (click)="clearRetailHQ(eachRetailHQ)" aria-hidden="true">×</span>
                                                  </div>
                                                  <span *ngIf="retaileHQList.length > 5" class="count regional-count"
                                                    [ngbPopover]="popContent" [autoClose]="false" #p="ngbPopover"
                                                    triggers="manual" (click)="p.open()"> + {{
                                                    retaileHQList?.length - 5 }}
                                                    <ng-template #popContent>
                                                      <div class="retail-text" id="retailText">{{retaileHQList?.length}}
                                                        {{globConst.ACTIVE_USRS_RETL_HQ}}
                                                        <span (click)="p.close()"><img alt="close"
                                                            class="modal-close-icon"></span>
                                                      </div>
                                                      <div class="multiple-chips" id="multipleChips">
                                                        <ng-container *ngIf="retaileHQList">
                                                          <div class="chip" *ngFor="let eachRetailHQ of retaileHQList" id="retailHQList">
                                                            <span>{{eachRetailHQ}}</span>
                                                            <span class="ng-value-icon right" aria-hidden="true">
                                                              <span class="retail-chips"
                                                                (click)="clearRetailHQ(eachRetailHQ)"><img alt="close"
                                                                  class="modal-close-icon"></span>
                                                            </span>
                                                          </div>
                                                        </ng-container>
                                                      </div>
                                                    </ng-template>
                                                  </span>
                                                  <span class="regional-add-more"
                                                    [ngClass]="!isSearchFilter?'clearFilter':'searchFilterData'">
                                                    <ng-select [placeholder]="addMore" [items]="allRetailHqData"
                                                      name="retail-drop" [clearable]="false" [selectOnTab]="true"
                                                      bindLabel="retailerName" bindValue="retailerId"
                                                      [(ngModel)]="valueForAssignedRetailHQ" [multiple]="true"
                                                      [closeOnSelect]="false" [clearSearchOnAdd]="true"
                                                      (search)="onSearch($event)">
                                                      <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                        let-index="index">
                                                        <div class="d-flex"
                                                          (click)="bindRetailHQ(item.retailerName,item.retailerId,$event)" id="bindRetailHQ">
                                                          <div id="itemIndex">
                                                            <input id="item-{{ index }}" type="checkbox"
                                                              [ngModel]="item$.selected"
                                                              [ngModelOptions]="{standalone: true}" />
                                                          </div>
                                                          <div id="itemRetailerName">
                                                            <span>{{ item.retailerName }}</span>
                                                          </div>
                                                        </div>
                                                      </ng-template>
                                                      <ng-template ng-multi-label-tmp let-items="items"
                                                        let-clear="clear">
                                                        <div class="ng-value" *ngFor="let item of items | slice: 0:5"
                                                          style="display:none" id="itemsRetailerName">
                                                          {{ item.retailerName }}
                                                          <span class="ng-value-icon right" (click)="clear(item)"
                                                            aria-hidden="true">×
                                                          </span>
                                                        </div>
                                                      </ng-template>
                                                    </ng-select>
                                                  </span>
                                                </div>
                                              </div>
                                              <div>
                                              </div>
                                            </div>
                                          </div>
                                        </ng-container>
                                        <div *ngIf='saveRegionalChanges'
                                          [ngClass]="(removedRetails?.length) ? 'card-desc' : 'pt-4'">
                                          <span *ngIf='removedRetails?.length' id="saveRegionalChanges">
                                            {{resultList.firstName}} {{resultList.lastName}}
                                            {{globConst.POPUP_CONFRMN_TXT}} {{removedRetails?.join(', ')}}.
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="modal-footer card-footer"
                                      *ngIf='!saveRegionalChanges && !savedRegional' id="cardFooterActiveUsr">
                                      <button type="button" (click)="closePopup()" class="btn btn-outline-primary">
                                        <span i18n="@@active-users.cancel">Cancel</span>
                                      </button>
                                      <button type="button" class="btn btn-primary" [disabled]="disableSaveChanges"
                                        (click)="saveRegionalHQModal(data?.userID)">
                                        <span i18n="@@active-users.save-updates.save-updates">Save Updates</span>
                                      </button>
                                    </div>
                                    <div class="convert-container" *ngIf="saveRegionalChanges" id="convertContainer">
                                      <div class="modal-header" id="modalHeaderRegional">
                                        <div (click)="closePopup()" class="close-icon" id="closePopup">
                                          <div class="popup-close-icon" id="popupCloseIcon"></div>
                                        </div>
                                      </div>
                                      <div class="modal-footer card-footer" *ngIf="saveRegionalChanges" id="regionalBtns">
                                        <button type="button" (click)="closeRegionalPopup()"
                                          class="btn btn-outline-primary btn-cancel">
                                          <span>{{globConst.NOT}}</span>
                                        </button>
                                        <button type="button" (click)='masterSaveRegional()'
                                          class="btn btn-primary btn-confirm">
                                          <span>{{globConst.YESS}}</span>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="modal-header" id="regionalUpdated">
                                      <div (click)="closeSavedPopup()" class="close-icon"
                                        *ngIf="savedRegional && !saveRegionalChanges" id="closeReginal">
                                        <div class="popup-close-icon" id="popupCloseRegional"></div>
                                      </div>
                                    </div>
                                    <div class="modal-body popup-body" *ngIf="savedRegional && !saveRegionalChanges" id="regionalPopupBody">
                                      <div class="success-img" id="successImgRegional"></div>
                                      <div class="convert-container" id="convertConRegional">
                                        <h2>
                                          <div class="m-auto text-center"><span
                                              i18n="@@active-users.updated-regional.updated">Updated</span></div>
                                        </h2>
                                      </div>
                                      <div class="card-desc text-center" id="cardDescName">
                                        <span
                                          i18n="@@active-users.retail-access.retail-hqs-that-can-be-accessed-by">Retail
                                          HQs that can be accessed by {{resultList.firstName}} {{resultList.lastName}}
                                          are
                                          updated</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf='!(data?.role === "deviceExecutive" || data?.role === retailHQUser || data?.role === regionalHQUser || data?.role === intelAdmin)' class="form-group" id="frmGrpStore">
                          <label><span i18n="@@active-users.label-store.store">Store</span></label>
                          <div class="exapnd_data_det" id="storeNameActiveUsr">{{ data?.storeName }}</div>
                        </div>
                        <div class="form-group" id="frmGrpRole">
                          <label><span i18n="@@active-users.role">Role</span></label>
                          <button type="button" [ngClass]="checkRole(data.role)" class="disableHand"
                            aria-haspopup="true" aria-expanded="false">
                            {{ spell(data?.role) }}
                          </button>
                        </div>
                      </div>
                      <div *ngIf='data?.role !== "deviceExecutive"' class="expand_editable_data_2" id="expandEditActiveUsr">
                        <div class="form-group" id="frmGrpCreatedBy">
                          <label><span>Created by</span></label>
                          <div class="text-color exapnd_data_det_id" id="createdByName">
                            {{ data?.createdByName }}
                          </div>
                        </div>
                        <div class="form-group"
                          *ngIf="(userRole === retailHQUser || userRole === intelAdmin || userRole === storeUser) && (data?.role === retailHQUser || data?.role === regionalHQUser || data?.role === storeUser)" id="roleConvertedBy">
                          <label><span>{{globConst.CONVERTED_BY}}</span></label>
                          <div class="text-color exapnd_data_det " id="expandConvertBy">{{ data?.convertedBy }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ID -->
                <div class="data_column" id="dataColumn">
                  <div id="expand_data_region"><span i18n="@@stores.store-user.address">Address</span></div>
                  <div class="expand_editable_data" id="expandLocation">
                    <div class="form-group" id="frmGrpLocation">
                      <label><span i18n="@@active-users.country">Location</span></label>
                      <div class="exapnd_data_det" id="dataLocation">{{ getTranslatedLoc(data?.location) }}</div>
                    </div>
                    <div class="form-group" id="activeUsrLanguage">
                      <label><span i18n="@@active-users.label-language.language">Language</span></label>
                      <div class="exapnd_data_det">{{ addSpaces(data?.language) | languageCodeToText }}</div>
                    </div>
                  </div>
                </div>
                <div class="edit-user-btns" id="editUsrBtns">
                  <div *ngIf='data.role === "nonConnectedUser"' id="noConectedUsr">
                    <button class="btn btn-primary" (click)='openPopup(convertPopup,data)'
                      [ngClass]="(data.role === 'nonConnectedUser' && (userRole === intelAdmin)) ? 'retail-convert-btn' : ''">{{globConst.CONVERT_USER}}</button>
                  </div>
                  <div *ngIf='data.role === retailHQUser && (userRole === intelAdmin)'
                    [ngClass]="(data.role === retailHQUser && (userRole === intelAdmin)) ? 'retail-convert-btn' : ''" id="retailConvertBtn">
                    <button class="btn btn-primary"
                      (click)='openPopup(convertRetailHqPopup,data)'>{{globConst.REGIONAL_CONVERT_USER}}</button>
                  </div>
                  <div *ngIf='data.role !== intelAdmin && userRole === intelAdmin' id="dataROle">
                    <button class="btn btn-primary" (click)='openEditUserModal(data)'>
                      <span i18n="@@active-users.transfer-user">Transfer User</span>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div class="text-center" *ngIf="!usersData?.length" id="txtCenterUsrData">
      <span *ngIf='!isLoading && isUsersDataEmpty else loading' i18n="@@active-users.expand.no-records-found">No Records
        Found</span>
      <ng-template #loading>
        <div class="text-center">{{globConst.LOADING}}</div>
      </ng-template>
    </div>
  </div>
  <!-- Pagination -->
  <div class="data_footer position-relative" *ngIf="usersData?.length > 0" id="posRelativeData">
    <button *ngIf="loginUserRole!='storeUser'" type="button"
      class="btn btn-outline-primary left_icon_btn download_btn gtmUsersActiveUsersDownloadCSV"
      (click)="downloadCsvFile()" [disabled]="usersData?.length == 0">
      <img class="downloadbtn" alt="download" />
      <span i18n="@@active-users.downloadbtn.download-csv">Download CSV</span>
    </button>
    <div class="d-flex flex-column align-items-center" *ngIf="loginUserRole!='storeUser'" id="storeUsr">
      <nav aria-label="existing profiles pagination">
        <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize" [rotate]="false"
          [maxSize]="maxSize" [ellipses]="true" [maxSize]="10" [boundaryLinks]="false"
          (pageChange)="onTableDataChange($event)">
        </ngb-pagination>
      </nav>
      <div class="results mt-2" id="shwoingShowFrm">
        <span i18n="@@active-users.results.showing-of-users" class="showing">Showing <strong>{{ showFrom }} - {{ showTo
            }}</strong> of <strong>{{ paginationCount }} Users</strong></span>
      </div>
    </div>
  </div>
</div>
<!-- Delete User Popup Start here -->
<div class="container" *ngIf="openDeleteModalPopup" id="deletePopupCon">
  <div class="modal-dialog-centered" id="modalDialogDeleteUsr">
    <div class="modal-backdrop show" id="modalBackdrpDeleteUsr"></div>
    <div class="modal" id="deleteUserModel">
      <div class="modal-dialog" id="deleteUserModelDialog">
        <div class="modal-content" *ngIf="isDeleted" id="deleteUserModelCon" [ngClass]="isDeleted ? 'confirmationPopupWidth' : ''">
          <div class="removesuccessmodal-close-icon" data-dismiss="modal" (click)="closeDeleteUserModal('cancel')" id="deleteUserModelIcon">
          </div>
          <div class="modal-body" id="deleteUserModelBody">
            <div class="heading remove_heading" id="deleteUserHeading">
              <span class="remove_content_text" i18n="@@active-users.delete-user-popup.are-sure-to-delete" *ngIf="!multiDeleteBtn">Are you sure you want to delete
                {{deleteMessage}} ?</span>
              <span class="remove_content_text" *ngIf="multiDeleteBtn">{{selectedCountValue > 1 ? globConst.DELETE_USERS_POPUP_HEADING_TEXT:checkedUser}}</span>
            </div>
            <p class="remove_text">
              <span *ngIf="!multiDeleteBtn && !userRoleDeviceExec">{{selectedCountValue > 1 ? globConst.DELETE_USER_POPUP_SUB_TEXT:globConst.DELETE_USER_POPUP_SUB_TEXT}}</span>
              <span *ngIf="multiDeleteBtn && !userRoleDeviceExec">{{selectedCountValue > 1 ?globConst.DELETE_USERS_POPUP_SUB_TEXT:globConst.DELETE_USER_POPUP_SUB_TEXT}}</span>
            </p>
          </div>
          <div class="modal-footer" id="modalFooterDeleteUsr">
            <button type="button" class="btn btn-outline-primary btn-lg gtmUsersActiveUsersCancel" data-dismiss="modal"
              (click)="closeDeleteUserModal('cancel')"><span i18n="@@active-users.cancel">Cancel</span></button>
            <button type="button" class="btn btn-primary btn-lg gtmUserDelete" (click)="deleteUser()">
              <span>{{multiDeleteBtn ? ( selectedCountValue > 1 ? globConst.DEL_USERS_POPUP_TEXT:globConst.DEL_USER_POPUP_TEXT):globConst.DEL_USER_POPUP_TEXT}}</span></button>
          </div>
        </div>
        <div class="modal-content" *ngIf="isDeleteConfirm" id="deletedUsrModalCon" [ngClass]="isDeleteConfirm ? 'confirmationPopupMessageWidth' : ''">
          <div class="card removePopup" id="cardDeleteUsr">
            <div class="modal-header" id="deleteModalHeader">
              <div class="removesuccessmodal-close-icon" data-dismiss="modal" (click)="closeDeleteUserModal()" id="rmvSuccessModal"></div>
            </div>
            <div class="modal-body" id="rmvSuccessImgModa;">
              <div class="removesuccess_img_div text-center" id="rmvImgDiv">
                <span class="removesuccess_img"></span>
              </div>
              <div class="removesuccess-title text-center" id="rmvSuccessTitle">
                <span i18n="@@active-users.delete-user-popup.deleted" *ngIf="!multiDeleteBtn">{{deleteMessage}} successfully deleted</span>
                <span i18n="@@delete-acknowledgement-popup.deleted-text" *ngIf="multiDeleteBtn">Deleted</span>
              </div>
              <div class="removesuccess-content text-center" id="rmvSuccessCon">
                <span *ngIf="multiDeleteBtn">{{globConst.DELETE_USERS_CNFRMN_SUB_TEXT}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Delete User Popup ends here -->
<!-- Show active users in table -->
<!-- invite store user -->
<div class="container" *ngIf="showInvitePopup" id="showInvitePopup">
  <div class="modal-backdrop show" id="modalBckDrpStoreUsr"></div>
  <!-- The Modal -->
  <div class="modal" id="inviteUserModal">
    <div class="modal-dialog modal-lg" id="inviteUserModalDialog">
      <form [formGroup]="inviteUserForm">
        <div class="modal-content"
          [ngClass]="{'russian-width': isRussian || isMexico || isGreek || isHungarian, 'polish-width' : isPolish || isNorwegian || isRomanian, 
                'indonesia-width':isIndonesia || isSwedish, 'thai-width':isThai || isDannish, 'german-width':isGerman || isUkraine, 'finnish-width':isFinnish || isCzech}" id="modalContent">
          <!-- Modal body -->
          <div class="modal-body search-dropdown" id="searchDropdwn">
            <button type="button" class="close" data-dismiss="modal" (click)="onCloseInvite()">
              <img class="modal-close-icon" alt="close" /></button>
            <h1 class=heading><span i18n="@@active-users.heading.invite-users.invite-users">Invite Users</span></h1>
            <div class="row" id="deleteRow">
              <div class="form-group col-7" id="emailAddresFrmGrp">
                <label for="email">
                  <span i18n="@@active-users.heading.email-addresses.email-addresses">Email Addresses</span><span
                    class="text-danger">*</span>
                </label>
                <div class="form-group form-group-md multi_email" #wrap
                  [ngClass]="{'multi_email-lang': isCzech || isRussian || isGreek || isSwedish || isGerman || isIndonesia || isPolish || isThai || isHungarian || isFinnish || isDannish || isNorwegian || isRomanian || isUkraine, 'invalid-user-identification': isUserValid }" id="wrap">
                  <div class="global-filter-chips" id="wrapGoblFilter">
                    <div class="global-filter-chip" *ngFor="let email of userEmailAddresses;  let i= index" id="usrEmailAddress">
                      <span class="global-filter-chip-text" (dblclick)="editEmail(i)">
                        {{email}}
                      </span>
                      <div class="remove-global-filter-btn" (click)="deleteEmail(i)" id="removeGlobalFilter">
                        <img class="modal-close-icon" alt="close" />
                      </div>
                    </div>
                  </div>
                  <div *ngIf="checkEdit" id="emailAddresFrmCon">
                    <input type="text" [placeholder]="" (paste)="onPaste($event)" (keyup)="onKeyUp($event)"
                      class="form-control" formControlName="emailAddress" (input)="avoidSpecialChar($event)"
                      class="editEmail">
                  </div>
                  <textarea *ngIf="!checkEdit" rows="1" id="email" name="email" class="form-control"
                    formControlName="emailAddress"
                    [placeholder]="userEmailAddresses?.length ? '':(enterAllEmailPlaceholderText)" required value=''
                    (keyup)="onKeyUp($event)" (focus)="addBorder(wrap)" (paste)="onPaste($event)"
                    (input)="avoidSpecialChar($event)" (blur)="removeBorder(wrap)"></textarea>
                </div>
                <div *ngIf="!isEmailrequired" class="formfield_err_msg mt-1" id="isEmailRequired"><span
                    i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required field.</span>
                </div>
                <div class="formfield_err_msg" *ngIf="!isEmailValid" id="frmFildErrMsg"><span
                    i18n="@@active-users.email-valid.please-provide-a-valid-email-address">Please provide a valid email
                    address.</span></div>
                <div class="formfield_err_msg" *ngIf="checkDuplicate" id="emailAlreadyAdd"><span
                    i18n="@@active-users.email-duplicate.email-already-added">Email already added</span></div>
                <div class="formfield_err_msg" *ngIf="checkDuplicateCount>0" id="emailAlreadyRegister"><span
                    i18n="@@active-users.email-register.email-already-registered">Email already Registered</span></div>
              <div class="formfield_err_msg invalid-user-error" *ngIf="isUserValid" id="invalidUser">
                <span>{{invalidUserErrorPretitle}}</span>
                <div style="font-weight: bold;" *ngFor="let email of invalidUserEmails">{{email}}</div>
                <span>{{invalidUserErrorPosttitle}}</span>
              </div>
              <div class="invite-users-note"><span>{{inviteUserNote}}</span></div>
                  </div> 
                                  
              <div class="form-group col-5" id="frmGrpBtn">
                <div ngbDropdown class="btn-group" id="frmBtnGrap">
                  <label for="OS"><span i18n="@@active-users.role">Role</span><span *ngIf="(userRole !== storeUser)" class="text-danger">*</span></label>
                  <button type="button" ngbDropdownToggle class="btn btn-primary btn-sm btn-dropdown-align"
                    [ngClass]="(showStore || showDeviceExecutive) ? 'store-color' : 'retailer-color'" id="roleDropdown" aria-haspopup="true"
                    aria-expanded="false" *ngIf="(userRole !==storeUser)">
                    {{valueForRole}}
                  </button>
                  <button type="button" class="btn btn-primary btn-sm btn-dropdown-align disableHand"
                    [ngClass]="showStore?'store-color':'retailer-color'" id="roleDropdown" aria-haspopup="true"
                    aria-expanded="false" *ngIf="(userRole===storeUser)">
                    {{valueForRole}}
                  </button>
                  <div ngbDropdownMenu aria-labelledby="roleDropdown" id="ngbDropDown_role">
                    <ng-container *ngFor="let data of allRoles">
                      <ng-container *ngIf="valueForRole!=data">
                        <a ngbDropdownItem title="{{data}}" (click)="onRoleChange(data)">{{data}}</a>
                      </ng-container>
                    </ng-container>
                  </div>

                </div>
                <div *ngIf="(valueForRole ==='Role') && isSubmitted"
                  class="formfield_err_msg formfield-err-msg-align-role" id="frmFieldActiveUsr">
                  <span i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required
                    field.</span>
                </div>
                <div class="form-group mt-4" id="activeUsrCountry">
                  <label for="OS" id="btnCountry" class="text-location"><span
                      i18n="@@active-users.country">Location</span><span *ngIf="(userRole !== storeUser)" class="text-danger">*</span></label><br>
                  <div class="drop-search" id="dropSearchLocation">
                    <ng-select [items]="allCountries" *ngIf="(userRole !== storeUser)"
                      placeholder="{{ locationSearch }}" bindLabel="CountryName" name="country" [clearable]="true"
                      [searchFn]="countrySearchFn" [(ngModel)]="valueForCountry" [ngModelOptions]="{standalone: true}"
                      [selectOnTab]="true" (change)="onCountryChange($event)">
                    </ng-select>
                    <div *ngIf="!valueForCountry" class="search-icon" id="searchIcon"></div>
                  </div>
                  <button type="button" class="btn btn-primary btn-sm  disableHand" id="countryDropDown"
                    aria-haspopup="true" aria-expanded="false" *ngIf="(userRole === storeUser)">
                    {{valueForCountry}}
                  </button>
                  <div *ngIf="!locationValueCopy && isSubmitted" class="formfield_err_msg formfield-err-msg-align" id="frmFildLocationValue"><span
                      i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required field.</span>
                  </div>
                </div>
                <div class="form-group mt-4" *ngIf="userRole === intelAdmin" id="assignedRetailHQ">
                  <div *ngIf="showStore" id="showStoreRetailHQ">
                    <label for="OS" id="btnRetailHQ"><span class='label-text'
                      i18n="@@active-users.retail.retail-hq">Retail HQ</span><span
                        class="text-danger">*</span></label><br>
                    <div class="drop-search" id="drpSearch">
                      <ng-select [items]="allRetailHqData"
                        placeholder="{{retailSearch}}" bindLabel="retailerName"
                        [ngbTooltip]="retailerName ? retailerName?.length > 15 ? retailerName:'':''"
                        bindValue="retailerID" name="retail-drop" [clearable]="true" [selectOnTab]="true"
                        [(ngModel)]="valueForRetailHq" [ngModelOptions]="{standalone: true}"
                        (change)="onRetailChange($event)">
                      </ng-select>
                      <div *ngIf="!retailHQValueCopy" class="search-icon" id="retailHQSearchIcon"></div>
                    </div>
                    <div *ngIf="!retailHQValueCopy && showStore && isSubmitted"
                    class="formfield_err_msg formfield-err-msg-align" id="storeValCopy"><span
                      i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required field.</span>
                    </div>
                  </div>
                </div>
                <div class="form-group mt-4" *ngIf = "userRole === intelAdmin && retailHQValueCopy" id="assignedFrmGrpAdmin">
                  <div *ngIf="showStore" id="showStore">
                    <label for="OS" id="btnCountry"><span class='label-text'
                        i18n="@@stores.dropdown.assigned-store-text">Assigned Store</span><span
                        class="text-danger">*</span></label><br>
                    <div class="drop-search" id="drpSearch">
                      <ng-select *ngIf="(userRole !== storeUser)" [items]="filteredStore" placeholder="{{storeSearch}}"
                        bindLabel="storeName" bindValue="storeId"
                        [ngbTooltip]="storeName ? storeName?.length > 15 ? storeName:'':''" name="store-drop"
                        [clearable]="true" [(ngModel)]="valueForStore" [ngModelOptions]="{standalone: true}"
                        [selectOnTab]="true" (change)="onStoreChange($event)">
                      </ng-select>
                      <div *ngIf="!valueForStore" class="search-icon" id="searchIconValStore"></div>
                    </div>
                    <button type="button" class="btn btn-primary btn-sm disableHand btn-ellipsis" id="storeHqDropDown"
                      aria-haspopup="true" aria-expanded="false" title="{{hovervalueForAssignedStore}}" placement='top'
                      [ngbTooltip]='valueForStore' *ngIf="(userRole === storeUser)">
                      <span class='text-overflow'> {{valueForStore}}</span>
                    </button>
                  </div>
                  <div *ngIf="!storeValueCopy && showStore && isSubmitted"
                    class="formfield_err_msg formfield-err-msg-align" id="storeValCopy"><span
                      i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required field.</span>
                  </div>
                </div>
                <div class="form-group mt-4" id="assignedFrmGrp">
                  <div *ngIf="showStore && userRole !== intelAdmin" id="showStore">
                    <label for="OS" id="btnCountry"><span class='label-text'
                        i18n="@@stores.dropdown.assigned-store-text">Assigned Store</span><span *ngIf="(userRole !==storeUser)"
                        class="text-danger">*</span></label><br>
                    <div class="drop-search" id="drpSearch">
                      <ng-select *ngIf="(userRole !== storeUser)" [items]="storesData" placeholder="{{storeSearch}}"
                        bindLabel="storeName" bindValue="storeId"
                        [ngbTooltip]="storeName ? storeName?.length > 15 ? storeName:'':''" name="store-drop"
                        [clearable]="true" [(ngModel)]="valueForStore" [ngModelOptions]="{standalone: true}"
                        [selectOnTab]="true" (change)="onStoreChange($event)">
                      </ng-select>
                      <div *ngIf="!valueForStore" class="search-icon" id="searchIconValStore"></div>
                    </div>
                    <button type="button" class="btn btn-primary btn-sm disableHand btn-ellipsis" id="storeHqDropDown"
                      aria-haspopup="true" aria-expanded="false" title="{{hovervalueForAssignedStore}}" placement='top'
                      [ngbTooltip]='valueForStore' *ngIf="(userRole === storeUser)">
                      <span class='text-overflow'> {{valueForStore}}</span>
                    </button>
                  </div>
                  <div *ngIf="!storeValueCopy && showStore && isSubmitted && userRole !== intelAdmin"
                    class="formfield_err_msg formfield-err-msg-align" id="storeValCopy"><span
                      i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required field.</span>
                  </div>
                  <div *ngIf="showRetailer" id="showRetailer">
                    <label for="OS" id="btnCountry"><span class='label-text'
                        i18n="@@active-users.label-assigned-retail-hq.assigned-retail-hq">Assigned Retail HQ</span><span
                        class="text-danger">*</span></label><br>
                    <div *ngIf="userRole === intelAdmin" class="drop-search" id="dropSearchVal">
                      <ng-select [items]="allRetailHqData"
                        placeholder="{{retailSearch}}" bindLabel="retailerName"
                        [ngbTooltip]="retailerName ? retailerName?.length > 15 ? retailerName:'':''"
                        bindValue="retailerID" name="retail-drop" [clearable]="true" [selectOnTab]="true"
                        [(ngModel)]="valueForRetailHq" [ngModelOptions]="{standalone: true}"
                        (change)="onRetailChange($event)">
                      </ng-select>
                      <div *ngIf="!retailHQValueCopy" class="search-icon" id="retailHQSearchIcon"></div>
                    </div>
                    <!--commenting Pc finder(srt user) user role code-->
                    <!-- <div class="multi-drop" id="pc_finder_select" *ngIf="userRole === intelAdmin && valueForRole === 'PC Finder User'">
                      <div class="border pc-block" id="srtListSelect">
                      <span class="add-more">
                      <ng-container *ngTemplateOutlet="retailHQMultiSelect"></ng-container>
                      </span>
                    </div>
                  </div> -->
                    <button type="button" *ngIf="(userRole === retailHQUser || userRole === regionalHQUser)"
                      class="btn btn-primary btn-sm disableHand" aria-haspopup="true" aria-expanded="false">
                      {{valueForRetailHq}}
                    </button>
                  </div>
                  <div *ngIf="showRetailer && !retailHQValueCopy && isSubmitted"
                    class="formfield_err_msg formfield-err-msg-align" id="requiredFrmField"><span
                      i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required field.</span>
                  </div>
                  <!-- commenting the below comments for oct release -->
                  <!-- <div *ngIf="showRetailer && valueForAssignedRetailHQ?.length < 1 && isSubmitted && valueForRole === 'PC Finder User'"
                  class="formfield_err_msg formfield-err-msg-align" id="requiredFrmField"><span
                    i18n="@@active-users.formfield-err-msg.this-is-a-required-field">This is a required field.</span>
                </div> -->
                </div>

              </div>
            </div>
          </div>          
          <!-- Modal footer -->
          <div class="modal-footer mt-3" id="modalFooterBtns">
            <button type="button" class="btn btn-outline-primary gtmUsersActiveUsersCancelInvite"
              (click)="onCloseInvite()"><span i18n="@@active-users.cancel">Cancel</span></button>
            <button type="button" class="btn btn-primary  gtmUsersActiveUsersInvite" (click)="onInviteStore()"><span
                i18n="@@active-users.invite-user.invite-user" class="gtmUsersActiveUsersInvite">Invite User</span></button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- Popup Modal ends Here -->

</div>
<!-- invite store user success popup -->
<div class="container" *ngIf="showsuccessInvitePopup" id="iviteStorUsrCon">
  <div class="modal-backdrop show" id="usrModalBackdrp"></div>
  <!-- The Modal -->
  <div class="modal" id="successUserModal">
    <div class="modal-dialog modal-lg" id="successUsrModalDialog">
      <div class="modal-content" id="successUsrModalCon">
        <div class="card invitePopup" id="successUsrCard">
          <div class="modal-header" id="successUsrModalHeader">
            <div class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="onCloseSuccessPopup()" id="inviteUsrModalIcon"></div>
          </div>
          <!-- Modal body -->
          <div class="modal-body invitesuccess-panel" id="successUsrModalbody">
            <div class="invitesuccess_img_div text-center" id="successModalInviteImg">
              <span class="invitesuccess_img"></span>
            </div>
            <div class="invitesuccess-title text-center" id="inviteSuccessTitle">
              <span i18n="@@active-users.heading-invite-sent">Invite Sent</span>
            </div>
            <div class="invitesuccess-content text-center" id="inviteSuccessCon"><span i18n="@@active-users.heading-invite-sent-to"
                *ngIf="showStore">Invite sent to {{invitedEmailString}} for {{storeName}}.</span></div>
            <div class="invitesuccess-content text-center" id="retailerNameInvite"><span i18n="@@active-users.heading-invite-sent-to"
                *ngIf="showRetailer && (retailerName || retailerNameLength <= 1)">Invite sent to {{invitedEmailString}} for
                {{retailerName || retailerNamePcFinder}}.</span></div>
                <div class="invitesuccess-content text-center" id="retailerNameInvite"><span
                  *ngIf="showRetailer && (retailerNameLength > 1) && !retailerName">Invite sent to {{invitedEmailString}} for the assigned Retail HQs.
                  </span></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Popup Modal ends Here -->

  </div>
</div>
<!-- Invite Users -->
<ng-template #convertPopup let-modal>
  <iposcen-spinner-overlay></iposcen-spinner-overlay>
  <!-- popupTemplates  -->
  <ng-template #cancelConvert>
    <button type="button" (click)="resetAll('cancelConvertPopup');modal.close()" class="btn btn-outline-primary btn-cancel">
      <span>{{globConst.CANCEL}}</span>
    </button>
    <button [disabled]='convertButtonEnable' type="button" (click)='confirmConvert=true'
      class="btn btn-primary btn-confirm">
      <span>{{globConst.CONVERT_USER}}</span>
    </button>
  </ng-template>
  <ng-template #mainClose>
    <div (click)="resetAll('cancelConvertPopup');modal.close()" class="close-icon" id="resetAllModal">
      <div class="popup-close-icon" id="popupCloseIcon"></div>
    </div>
  </ng-template>
  <ng-template #convertClose>
    <div (click)="confirmConvert=false" class="close-icon" id="convertClose">
      <div class="popup-close-icon" id="confirmConvertClose"></div>
    </div>
  </ng-template>
  <!-- popupTemplates  -->
  <div class="card confirmPopup" id="cardConfirmPopup">
    <div class="modal-header" id="modalTemplatesHeader">
      <ng-container *ngTemplateOutlet='!confirmConvert? mainClose:closeElse'></ng-container>
      <ng-template #closeElse>
        <ng-container *ngTemplateOutlet='!convertDone?convertClose:mainClose'></ng-container>
      </ng-template>
    </div>
    <div class="modal-body popup-body" id="modalBodyTemplates">
      <div *ngIf='convertDone' class="success-img" id="convertSuccessImg"></div>
      <div class="convert-container" id="convertConActiveUsr">
        <h2>
          <ng-container *ngIf='!convertDone'>
            <span *ngIf='!confirmConvert; else elseTitle'>{{globConst.CONVERT_USER}}</span>
            <ng-template #elseTitle>
              <span i18n="@@active-users.convert-popup.do-you">Do you want to convert this user to a connected user
                role?</span>
            </ng-template>
          </ng-container>
          <div *ngIf='convertDone' class="m-auto text-center" id="globConstConverted">{{globConst.CONVERTED}}</div>
        </h2>
        <ng-container *ngIf='!convertDone'>
          <div class="card-desc" [ngClass]="{'hide':confirmConvert,'show':!confirmConvert}" id="cardDescCOnvert">
            <div id="globConstEmailId">
              <div id="globConstEmailpopup">
                <div for="emailPopup" id="emailPopupConvert">{{globConst.EMAIL_ID}}</div>
                <input class="disabled-input" type="text" [value]='convertUserData.email' [disabled]='true'>
              </div>
              <div class="mt-3" id="globConstRoleMain">
                <div class="mb-2" id="globConstRoleChild">
                  <span>{{globConst.ROLE}} <span class="text-danger">*</span></span>
                </div>
                <div ngbDropdown class="d-inline-block" id="ngbDropDown">
                  <button class="btn btn-primary" id="selectRole" ngbDropdownToggle>
                    {{selectedRoleInput===globConst.SELECT_ROLE?globConst.ROLE:''}}
                    {{selectedRoleInput===globConst.STORE?globConst.DISPLAY_STORE:''}}
                    {{selectedRoleInput===globConst.RETAIL_HQ?globConst.ACTIVE_USRS_RETL_HQ:''}}
                  </button>
                  <div ngbDropdownMenu aria-labelledby="selectRole" id="ngbDropDownBtns">
                    <button *ngIf='selectedRoleInput !== globConst.STORE' (click)='checkConvertFields(globConst.STORE)'
                      ngbDropdownItem>{{globConst.DISPLAY_STORE}}</button>
                    <button *ngIf='selectedRoleInput !== globConst.RETAIL_HQ'
                      (click)='checkConvertFields(globConst.RETAIL_HQ)' ngbDropdownItem>
                      {{globConst.ACTIVE_USRS_RETL_HQ}}
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <div *ngIf='selectedRoleInput===globConst.RETAIL_HQ || selectedRoleInput === globConst.STORE'
                  class="mt-3" id="activeUsrRetlHQMain">
                  <div class="mb-2" id="activeUsrRetlHQChild">{{globConst.ACTIVE_USRS_RETL_HQ}}<span class="text-danger"> *</span></div>
                  <div class="selection-dropdown" id="selectionDrpDwn">
                    <ng-select #retailSelector placement="top"
                      [ngbTooltip]="convertRetailerData ? convertRetailerData.retailerName.length > 30?convertRetailerData.retailerName:'':''"
                      [items]="displayDropDownRetail" [placeholder]="retailSearch" bindLabel="retailerName"
                      bindValue="retailerID" name="retail-drop" [clearable]="true" [selectOnTab]="true"
                      [notFoundText]='globConst.NO_DATA_FOUND' (change)='selectToConvert($event,globConst.RETAIL_HQ)'>
                    </ng-select>
                    <div *ngIf='!convertRetailerData' class="search-icon" id="convertRetailerData"></div>
                  </div>

                </div>
                <div class="mt-3" *ngIf='selectedRoleInput === globConst.STORE' id="globConstRoleInput">
                  <div class="mb-2" id="globConstDisplayStore">{{globConst.DISPLAY_STORE}}<span class="text-danger"> *</span></div>
                  <div class="selection-dropdown" id="storeSearchValue">
                    <ng-select placement="top" [disabled]="!convertRetailerData"
                      [ngbTooltip]="convertStoreData ? convertStoreData.storeName.length > 30?convertStoreData.storeName:'':''"
                      [items]="displayConvertStore" [placeholder]="globConst.DISPLAY_STORE" bindLabel="storeName"
                      bindValue="storeId" [(ngModel)]="storeSearchValue" [ngModelOptions]="{standalone: true}"
                      name="store-drop" (change)='selectToConvert($event,globConst.STORE)' [clearable]="true"
                      [selectOnTab]="true" [notFoundText]='globConst.NO_DATA_FOUND'>
                    </ng-select>
                    <div *ngIf='!convertStoreData' class="search-icon" id="convertStoreData"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-desc" [ngClass]="{'hide':!confirmConvert,'show':confirmConvert}" id="convrsnCantBeReversed">
            <span i18n="@@active-users.card-desc.con-cannot-reversed">The conversion cannot be reversed</span>
          </div>
        </ng-container>
        <div class="card-desc text-center" *ngIf='convertDone' id="cardDescConvertDone">
          <span i18n="@@active-users.card-desc.success-msg">{{convertUserData.firstName}} {{convertUserData.lastName}}
            has been converted as
            {{selectedRoleInput===globConst.STORE?globConst.DISPLAY_STORE:globConst.ACTIVE_USRS_RETL_HQ}} user for
            {{selectedRoleInput ===
            globConst.RETAIL_HQ?convertRetailerData.retailerName:convertStoreData.storeName}}.</span>
        </div>

      </div>
    </div>
    <div *ngIf='!convertDone' class="modal-footer card-footer" id="cardFooterCovert">
      <ng-container *ngTemplateOutlet='confirmConvert?noYes:cancelConvert'></ng-container>
    </div>
  </div>
</ng-template>
<ng-template #noYes>
  <button type="button" (click)='confirmConvert=false' class="btn btn-outline-primary btn-cancel">
    <span>{{globConst.NOT}}</span>
  </button>
  <button type="button" (click)='masterConvert()' class="btn btn-primary btn-confirm gtmConfirmConvert">
    <span>{{globConst.YESS}}</span>
  </button>
</ng-template>

<!-- Retail HQ multiselect Template -->
<ng-template #retailHQMultiSelect>
  <div id="drpFinderSearch">
  <ng-select [placeholder]="addMore" [items]="allRetailHqData" name="retail-drop" [clearable]="true"
    [selectOnTab]="true" bindLabel="retailerName" bindValue="retailerId" [(ngModel)]="valueForAssignedRetailHQ"
    (change)="onAssignedRetailChange(valueForAssignedRetailHQ)" [multiple]="true" [closeOnSelect]="false"
    [clearSearchOnAdd]="true">
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <div class="row" id="retailerNameRow">
        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
        {{ item.retailerName }}
      </div>
    </ng-template>
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="ng-value" *ngFor="let item of items | slice: 0:4" id="retailerNameVal">
        {{ item.retailerName }}
        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×
        </span>
      </div>    
    </ng-template>
  </ng-select>
   <!-- commenting pc finder (srt user) role code-->
  <!-- <div *ngIf="valueForRole === 'PC Finder User' && (!valueForAssignedRetailHQ || valueForAssignedRetailHQ?.length < 1)" class="pc-finder-search-icon" id="pcFindersearchIcon"></div> -->
  </div>
  <span *ngIf="assignedRetailHQ && assignedRetailHQ.length > 4" [ngbPopover]="popContent" [autoClose]="false"
    #p="ngbPopover" triggers="manual" class="count" (click)="p.open()"> + {{
    assignedRetailHQ?.length - 4 }}
    <ng-template #popContent>
      <div class="retail-text" id="activeUsrRetailer">{{assignedRetailHQ?.length}} {{globConst.ACTIVE_USRS_RETL_HQ}}
        <span (click)="p.close()"><img alt="close" class="modal-close-icon"></span>
      </div>
      <div class="multiple-chips" id="multiChipsRetail">
        <ng-container *ngIf="assignedRetailHQ">
          <div class="chip" *ngFor="let item of assignedRetailHQ;let i=index" id="chipAssignRetailHQ">
            {{displaySelectedRegional.get(item)}}
            <span class="ng-value-icon right" aria-hidden="true">
              <span class="retail-chips" (click)="deleteAssignedRetailHQ(item)"><img alt="close"
                  class="modal-close-icon"></span>
            </span>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </span>
</ng-template>

<div *ngIf="openEditUserModalPopup" id="myModalEditUsr">

  <div class="modal-dialog modal-dialog-centered" id="myModalCenterEditUsr">
    <div class="modal-backdrop show" id="modalBackDrpEditUsr"></div>
    <div class="modal" id="modalEditUsr">

      <div class="modal-dialog" id="modalDialogEditUsr">
        <div class="modal-content edit-user-modal-content confirmPopup" id="modalEditUsrContent">
          <div class="close" data-dismiss="modal" (click)="closeEditUserModal()" id="modalEditUsrClose">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div class="modal-body" *ngIf="!isUserInofUpdated" id="modalEditUsrBody">
            <div class="convert-container" id="modalEditUsrConvertCon">
              <h2>
                <ng-container>
                  <span i18n="@@active-users.label-account.transfer-account">Transfer Account</span>
                </ng-container>
              </h2>
              <span><span class="text-danger">* </span> indicates a required field</span>
              <ng-container>
                <div class="card-desc mt-3" id="modalEditUsrCard">
                  <div id="cardDescChildDiv">
                    <div id="FirstNameDiv">
                      <span i18n="@@active-users.label-firstname.first-name">First Name <span
                          class="text-danger">*</span></span>
                    </div>
                    <input [(ngModel)]="editedFirstName" class="card-desc-tranfer-usr-fields" type="text">
                  </div>
                  <div class="mt-3" id="cardDescChild1Div">
                    <div id="lastNameDiv">
                      <span i18n="@@active-users.label-lastname.last-name">Last Name <span
                          class="text-danger">*</span></span>
                    </div>
                    <input [(ngModel)]="editedLastName" class="card-desc-tranfer-usr-fields" type="text">
                  </div>
                  <div class="mt-3" id="globlConstEmailID">
                    <div for="editUserInfoModal" id="editUsrInfoModalEmai">{{globConst.EMAIL_ID}} <span class="text-danger">*</span></div>
                    <input [(ngModel)]="editedEmailID" class="card-desc-tranfer-usr-fields" type="text">
                    <div *ngIf="!isEditedEmailCorrect" class="text-danger" id="isEditEmaiCorrect">
                      Please provide a valid email address.
                    </div>
                    <div *ngIf="isEmailAlreadyRegistered" class="text-danger" id="isEmailAlryRegister">
                      Email ID already exists
                    </div>
                  </div>
                </div>
              </ng-container>

            </div>
          </div>
          <div class="modal-body popup-body" *ngIf="isUserInofUpdated" id="modalBody">
            <div class="success-img" id="successImgIsUsrInfo"></div>
            <div class="convert-container" id="convertConUsrInfo">
              <h2>
                <div class="m-auto text-center">Updated</div>
              </h2>
            </div>
            <div class="card-desc text-center" id="usrInfoSuccessful">
              <span>User info updated successfully</span>
            </div>
          </div>
          <div class="modal-footer card-footer" *ngIf="!isUserInofUpdated" id="isUsrInfoUpdated">
            <button type="button" class="btn btn-primary" (click)="updateUserInfo()"
              [disabled]="!(editedFirstName && editedLastName && editedEmailID)">
              <span>Save Updates</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>

<div>

</div>

<ng-template #convertRetailHqPopup let-modal>
  <iposcen-spinner-overlay></iposcen-spinner-overlay>
  <!-- popupTemplates  -->
  <ng-template #cancelConvert>
    <button type="button" (click)="resetAll('cancelConvertPopup');modal.close()" class="btn btn-outline-primary btn-cancel">
      <span>{{globConst.CANCEL}}</span>
    </button>
    <button [disabled]='!assignedRetailHQ.length' type="button" (click)='confirmConvert=true'
      class="btn btn-primary btn-confirm">
      <span>{{globConst.CONVERT_USER}}</span>
    </button>
  </ng-template>
  <ng-template #mainClose>
    <div (click)="resetAll('cancelConvertPopup');modal.close()" class="close-icon" id="mainCloseDiv">
      <div class="popup-close-icon" id="popupCloseIconDiv"></div>
    </div>
  </ng-template>
  <ng-template #convertClose>
    <div (click)="confirmConvert=false" class="close-icon" id="confirmCovertFalse">
      <div class="popup-close-icon" id="closeIconConfirm"></div>
    </div>
  </ng-template>
  <!-- popupTemplates  -->
  <div class="card confirmPopup" id="confrmPopupTemplates">
    <div class="modal-header" id="modalHeaderTemplates">
      <ng-container *ngTemplateOutlet='!confirmConvert? mainClose:closeElse'></ng-container>
      <ng-template #closeElse>
        <ng-container *ngTemplateOutlet='!convertDone?convertClose:mainClose'></ng-container>
      </ng-template>
    </div>
    <div class="modal-body popup-body multi-drop" id="multiDropPopup">
      <div *ngIf='convertDone' class="success-img" id="successImgPopup"></div>
      <div class="convert-container" id="convertICon">
        <h2>
          <ng-container *ngIf='!convertDone'>
            <span *ngIf='!confirmConvert; else elseTitle'>{{globConst.REGIONAL_CONVERT_USER}}</span>
            <ng-template #elseTitle>
              <span i18n="@@active-users.convert-regional.do-you">Do you want to convert this user to a Regional HQ
                User?</span>
            </ng-template>
          </ng-container>
          <div *ngIf='convertDone' class="m-auto text-center" id="covertDoneGloblConst">{{globConst.CONVERTED}}</div>
        </h2>
        <ng-container *ngIf='!convertDone'>
          <div class="card-desc" [ngClass]="{'hide':confirmConvert,'show':!confirmConvert}" id="cardDescConfrmConvert">
            <div id="emailPopupConvertDon">
              <div id="convertUsrDataEmail">
                <div for="emailPopup" id="emailPopup">{{globConst.EMAIL_ID}}</div>
                <input class="disabled-input" type="text" [value]='convertUserData.email' [disabled]='true'>
              </div>
              <div class="mt-3" id="globConstCountryNote">
                <div id="globConstCountryNote">
                  <span>{{globConst.COUNTRY}}</span>
                </div>
                <span class="note-color" i18n="@@active-users.note-regional"><strong>Note:</strong> The Regional user
                  operates from this location, which is independent of any
                  Retail HQs associated to the Regional user.</span>
                <input class="mt-2 disabled-input" type="text" [value]='convertUserData.location' [disabled]='true'>
                <div class="mt-2" id="retailHQsAssign">
                  <span i18n="@@active-users.retail-hq.to-assign">Retail HQs to be Assigned</span>
                </div>
                <div class="mt-2 border" id="covertUsrRetailName">
                  <span class="chip">{{convertUserData.retailerName}}</span>
                  <span [ngClass]="{'add-more-text-caption':valueForAssignedRetailHQ?.length < 1}" class="add-more">
                    <ng-container *ngTemplateOutlet="retailHQMultiSelect"></ng-container>
                  </span>
                </div>
              </div>
              <div>
              </div>
            </div>
          </div>
          <div class="card-desc" [ngClass]="{'hide':!confirmConvert,'show':confirmConvert}" id="conCantBeReversed">
            <span i18n="@@active-users.card-desc.con-cannot-reversed">The conversion cannot be reversed</span>
          </div>
        </ng-container>
        <div class="card-desc text-center" *ngIf='convertDone' id="convertUsrDataName">
          <span i18n="@@active-users.success-regional">{{convertUserData.firstName}} {{convertUserData.lastName}} has
            been converted to a Regional
            User.</span>
        </div>

      </div>
    </div>
    <div *ngIf='!convertDone' class="modal-footer card-footer" id="confrmConvertNoYes">
      <ng-container *ngTemplateOutlet='confirmConvert?noYes:cancelConvert'></ng-container>
    </div>
  </div>
</ng-template>